import PageTitle from "../page-header/PageHeader";
import GetAllProd from "./getAllProd";
import GetAllRunningSize from "./getAllRunningSize";

import { Navigate, Link } from "react-router-dom";
import { Button, Space } from "antd";
import { PlusOutlined, GroupOutlined } from "@ant-design/icons";
import AddProd from "./addProd";
import AddRunningSize from "./addRunningSize";

const Product = (props) => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to={"/auth/login"} replace={true} />;
  }

  return (
    <>
      <PageTitle title="Back" />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16, gap: 8 }}>
        <Link to="/item-group">
          <Button icon={<GroupOutlined />}>
            Item Groups
          </Button>
        </Link>
        <Link to="/running-size/bulk-add">
          <Button type="primary" icon={<PlusOutlined />}>
            Bulk Add Running Sizes
          </Button>
        </Link>
      </div>

      <AddRunningSize/>
      <GetAllRunningSize />
    </>
  );
};

export default Product;
